var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.483 5.457a.75.75 0 011.034 0l2.8 2.667a.75.75 0 01-1.034 1.086L12.75 7.75V14a.75.75 0 01-1.5 0V7.75L9.717 9.21a.75.75 0 11-1.034-1.086l2.8-2.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56 15.025a.75.75 0 01.916.535l.434 1.656a.58.58 0 00.219.317c.114.084.26.134.414.134h10.415c.154 0 .3-.05.413-.134a.58.58 0 00.22-.317l.434-1.656a.75.75 0 011.45.38l-.434 1.657a2.08 2.08 0 01-.774 1.14c-.378.28-.84.43-1.31.43H6.544c-.47 0-.931-.15-1.31-.43a2.08 2.08 0 01-.774-1.14l-.434-1.657a.75.75 0 01.535-.915z"
  })));
}
export default SvgShareIcon;